import {
  Transforms,
  Path,
  Node
} from 'slate';

import elementTypes from '../../elements/types';
import HelptapEditor from '../';
import * as baseNodeUtilities from './base-node';

export function getDefaultOptions() {

  const options = baseNodeUtilities.getDefaultOptions();

  return options;

}

export function buildNode(type, options = {}) {

  const node = {
    ...getDefaultOptions(),
    ...options,
    type
  };

  return node;

}

export function insert(editor, type, insertOptions) {

  Transforms.insertNodes(editor, buildNode(type), {
    at: insertOptions.at.path
  });
  Transforms.select(editor, [...insertOptions.at.path, 0]);

}

export function toggle(editor, type) {

  const node = buildNode(type);

  HelptapEditor.setNodeOptions(editor, node);

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = HelptapEditor.cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}

export function handleDeleteBackward(editor, topLevelNode, topLevelNodePath) {

  if (Path.hasPrevious(topLevelNodePath) === false) {
    return false;
  }

  const previousNodePath = Path.previous(topLevelNodePath);
  const previousNode = Node.get(editor, previousNodePath);

  if (previousNode.type !== elementTypes.TOGGLE_LIST_ITEM) {
    return false;
  }

  const targetPath = HelptapEditor.toggleListItem.appendNode(editor, previousNodePath, topLevelNodePath);
  Transforms.select(editor, [...targetPath, topLevelNode.children.length - 1]);
  Transforms.collapse(editor, { edge: 'start' });
  return true;

}